import { createSelector } from "reselect";
import { AppState } from "../..";
import { Rating } from "../../../sharedComponents";

// Base selector
const getRatingState = (state: AppState) => state.ratings;

// Memoized rating selector
export const getRating = createSelector([getRatingState], (ratingState) => ratingState.rating as Rating);

// Derived rating selectors to prevent re-computation
export const getIsPositiveRating = createSelector([getRating], (rating) => rating === Rating.POSITIVE);

export const getIsNegativeRating = createSelector([getRating], (rating) => rating === Rating.NEGATIVE);
